declare global {
  interface Window {
    AndroidInterface?: {
      postMessage: (action: string, data?: string) => void;
    };
  }
}

export enum AndroidMessages {
  OutboxBackEmails = 'back-emails',
  OutboxBackGetLinks = 'back-get-links',
  OutboxBackOutlook = 'back-outlook',
  ResourcePreview = 'resource-preview',
  OrderHealthExport = 'orderHealthExport',
  InvoicesExport = 'invoicesExport',
  ARExport = 'arExport'
}

export const useAndroidCommunication = () => {
  const sendMessageToAndroid = (
    action: AndroidMessages | string,
    data?: unknown
  ) => {
    if (window?.AndroidInterface) {
      window.AndroidInterface.postMessage(
        action,
        data !== undefined ? JSON.stringify(data) : undefined
      );
    } else {
      // eslint-disable-next-line no-console
      console.error('No AndroidInterface found for Android communication');
    }
  };

  const isAndroid = !!window?.AndroidInterface;

  return { sendMessageToAndroid, isAndroid };
};
